const Form102TC = {
    stepName: {
        importantNotes: "重要事項",
        organization: "主辦機構",
        owner: "擁有人/主辦者",
        contactPerson: "聯絡人",
        proposedCourse: "擬舉辦課程/講座",
        teacher: "教師/講者",
        attachments: "附件",
        declaration: "擁有人/主辦者聲明",
        confirmation: "確認",
    },
    label: {
        organization: "主辦機構",
        enOrganization: "主辦機構英文名稱",
        cnOrganization: "主辦機構中文名稱",
        tel: "電話號碼",
        fax: "傳真號碼",
        enAddress: "英文地址",
        cnAddress: "中文地址",
        making: "非牟利機構",
        makingOptions: {
            yes: "是",
            no: "否",
        },
        makingYes:
            "(如是，請附文件（如稅務局信件）證明主辦機構為非牟利慈善團體。) ",
        backgroundAndService: "背景和提供的服務",
        attach: "請附詳情。",
        title: "稱謂",
        enName: "英文姓名",
        cnName: "中文姓名",
        hkid: "身份證號碼",
        enTitleOptions: {
            mr: "Mr",
            mrs: "Mrs",
            miss: "Miss",
            ms: "Ms",
        },
        cnTitleOptions: {
            mr: "先生",
            mrs: "太太",
            miss: "小姐",
            ms: "女士",
        },
        cnTitleNote: "如果沒有中文姓名，請留空。",
        contactNote: "<i>（教育局完成審批後，會將申請結果及相關文件郵寄予<b>「聯絡人」</b>。）</i>",
        contactSurname: "姓",
        contactOtherName: "名",
        contactEmail: "電郵地址",
        contactAddress: "聯絡地址",
        briefDescription: "簡介",
        proposedCourseTitle: "名稱",
        relevantInformation: "請附有關資料。",
        targetParticipants: "對象",
        fees: "收費 (港幣)",
        proposedPeriod: "擬訂期限(不得超過一年)",
        dateFrom: "擬訂期限(不得超過一年)由",
        dateTo: "至",
        otherDetails: "其他資料",
        centreName: "中心名稱",
        venue: "地點",
        time: "舉辦時間(請列明每週舉辦天數及時間,  例如︰逢星期一至五下午2:00至6:00)",
        providingAcademic:
            "提供學術授課的時間(請列明每週舉辦天數及時間, 例如︰逢星期一至五下午3:00至4:45, 包括10分鐘小息)",
        timeRemark: "備註: (例如︰包括10分鐘小息)",
        estimatedEnrolment: "估計參加人數",
        additionalSheet: "如有需要請加附頁。",
        occupation: "職業",
        qualification: "學歷",
        iAttach: "本人現附呈",
        lectureContents: "擬舉辦課程/講座的資料/內容",
        informationOrganization: "主辦機構的資料",
        copies: "教師/講者學歷證明文件副本、檢定教員證明書或准用教員許可證副本，並在副本上簽署證明本人已查閱正本",
        others: "其他",
        i: "本人",
        criminalOffenceOp: {
            yes: "有",
            no: "沒有",
        },
        criminalOffence: "被裁定已犯有刑事罪行；",
        declare: "就本人所知所信，本申請書一切內容均屬真實及詳盡。",
    },
    errorMsg: {
        notExceedingOneYear: "請選擇自今日起不超過一年的時間",
        ownerTitleEn: "請選擇與中文一致的稱謂",
        ownerTitleCn: "請選擇與英文一致的稱謂",
    },
    dialog: {
        title: "注意",
        content:
            "請列印已填妥的申請表及人手簽署，並將簽妥的申請表提交至教育局學校註冊及監察組 (辦事處地址︰香港柴灣利眾街24號東貿廣場28樓)。教育局在收到簽妥的申請表後會處理有關申請。",
        successfulFormSubmission: "成功遞交表格至機構審批人",
        successfulSubmissionMsgToA:
            "你已成功把表格遞交予貴機構的審批人。請提醒機構審批人簽署及向教育局提交申請表。",
        notice: "通知： 此表格尚未提交給教育局。 請在表格上簽名並提交。",
        approveNotice: "通知：收到申請。等待教育局批准並發出豁免令。",
        receiveNotice: "通知：收到申請。請處理。",
        submittedCannotEdited: "表格提交後，不能再編輯。",
        successfulSubmissionMsg2: "確認電郵已發送至你的註冊電郵地址。",
    },
};
export default Form102TC;
